import './round-question.scss';
import Logo from '../../assets/logo-small.svg';
import Button from '../../components/button/button';
import ModalStatusRound from '../../components/modal-status-round/modal-status-round';
import { useState, useEffect, useRef } from 'react';
import { useLocation } from "react-router-dom";
import { SERVER } from '../../env';
import moment from 'moment';
import IndividualChallengeService from '../../services/individual-challenge-service';
import LocalStorage from '../../services/local-storage';
import { TEAM, SESSION, SCORE, ASSETS } from '../../constants';
import TranslateService from '../../services/translate-service';
import UtilsService from '../../services/utils-service';
import Avatar from  '../../components/avatar/avatar';
import ICON_BONUS from '../../assets/icon-bonus.png';

export default function RoundQuestion() {

    const { state } = useLocation();

    const timerBonus = useRef(null);
    const iconBonus = useRef(null);

    const [team] = useState(LocalStorage.get(TEAM));
    const [session] = useState(LocalStorage.get(SESSION));
    const [myScore] = useState(LocalStorage.get(SCORE));

    const [TIME_LIMIT_QUICK_ANSWER] = useState(10);
    const [POINTS_QUICK_ANSWER] = useState(2);
    const [POINTS_CORRECT_ANSWER] = useState(10);

    const [opponent, setOpponent] = useState(state.round.oponente);
    const [counterBack, setCounterBack] = useState(3);
    const [isPreparing, setIsPreparing] = useState(true);
    const [questions, setQuestions] = useState([]);
    const [currentQuestion, setCurrentQuestion] = useState(null);
    const [myAnswer, setMyAnswer] = useState(null);
    const [stats, setStats] = useState([]);
    const [time, setTime] = useState(0);
    const [responseRound, setResponseRound] = useState(null);

    useEffect(() => {
        setOpponent(state.round.oponente)
        setCounterBack(3);
        setIsPreparing(true);
        setQuestions([]);
        setCurrentQuestion(null);
        setMyAnswer(null);
        setStats([]);
        setTime(0);
        setResponseRound(null);

        const interval = setInterval(() => {
            setCounterBack(counterBack => {

                if (counterBack === 0) {
                    clearInterval(interval)
                    setIsPreparing(false)
                    return 0;
                } else {
                    return counterBack - 1
                }
            })

        }, 1000);

        return () => clearInterval(interval);

    }, [state.reload, state.round.oponente]);
    
    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setCounterBack(counterBack => {

    //             if (counterBack === 0) {
    //                 clearInterval(interval)
    //                 setIsPreparing(false)
    //                 return 0;
    //             } else {
    //                 return counterBack - 1
    //             }
    //         })

    //     }, 1000);

    //     return () => clearInterval(interval);
    // }, []);

    useEffect(() => {
        if (!isPreparing) {
            let questionsTMP = state.round.preguntas.sort(() => 0.5 - Math.random());

            let question = questionsTMP.shift();
            let options = [
                question.opcion1,
                question.opcion2,
                question.opcion3,
                question.opcion4,
            ];

            question.options = options.sort(() => 0.5 - Math.random());
            setCurrentQuestion(question);
            setQuestions(questionsTMP);
        }
    }, [isPreparing, state.round.preguntas]);

    useEffect(() => {
        if (currentQuestion) {
            initTimer()
            setTime(moment())
        }
    }, [currentQuestion]);

    const preparing = () => {

        if (!isPreparing) return null;

        return (
            <div className='text-center pb-14 mt-[100px]'>
                <h1 className='heading-h1 !text-white mb-5'>{TranslateService.get('indivualChall.challenges.round.title')}</h1>
                <p className='heading-h6 uppercase  !text-white text-center' >{TranslateService.get('indivualChall.challenges.round.description')}</p>

                <div className='flex items-center justify-center mt-[108px]'>
                    <div>
                        <div className='card-player'>
                            <Avatar className='mx-auto avatar-pink !w-[84px] !h-[84px]' image={ `${ASSETS.AVATAR_PLAYER}${session.avatar}` }/>
                            <p className='heading-h6 !text-white mt-3'>You</p>
                            <p className='heading-h6 !text-white points'>{UtilsService.format(myScore)} pts</p>
                        </div>
                    </div>
                    <div className='px-[48px]'>
                        <div className='vs'>VS</div>
                    </div>
                    <div>

                        <div className='card-player'>
                            <Avatar className='mx-auto avatar-purple !w-[84px] !h-[84px]' image={ `${ASSETS.AVATAR_PLAYER}${opponent.avatar}` }/>
                            <p className='heading-h6 !text-white mt-3'>{UtilsService.capitalize(opponent.nombre, opponent.apellidoPaterno) }.</p>
                            <p className='heading-h6 !text-white points'>{UtilsService.format(opponent.score)} pts</p>
                        </div>
                    </div>

                </div>

                <h1 className='heading-h1 !text-white !text-[64px] mt-[159px] '>{counterBack}</h1>
            </div>
        )
    }

    const handleAnswer = (index, option) => {
        if (myAnswer) return;

        timerBonus.current.style.animationPlayState = 'paused';
        iconBonus.current.style.animationPlayState = 'paused';

        let timeEnd = moment();
        let diff = +(timeEnd.diff(time, 'seconds', true).toFixed(2));
        option.diff = diff;
        option.index = index;
        option.points = option.esCorrecta ? POINTS_CORRECT_ANSWER : 0;
        option.extraPoints = option.esCorrecta ? calculateExtraPoints(diff) : 0;

        let statsTMP = [...stats];
        statsTMP.push({
            pregunta: currentQuestion._id,
            tiempo: option.diff,
            puntos: option.points + option.extraPoints,
            esCorrecta: option.esCorrecta
        });

        setStats(statsTMP);
        setMyAnswer(option);
    }

    const calculateExtraPoints = (diff) => {
        const chunk = TIME_LIMIT_QUICK_ANSWER / 4;

        if (diff >= 0 && diff < chunk) {
            return POINTS_QUICK_ANSWER * 4;
        }

        if (diff >= chunk && diff < chunk * 2) {
            return POINTS_QUICK_ANSWER * 3;
        }

        if (diff >= chunk * 2 && diff < chunk * 3) {
            return POINTS_QUICK_ANSWER * 2;
        }

        if (diff >= chunk * 3 && diff < chunk * 4) {
            return POINTS_QUICK_ANSWER;
        }

        return 0;

    }

    const nextQuestion = () => {

        let questionsTMP = [...questions];

        if (!questionsTMP.length) {
            return saveStats();
        }

        let question = questionsTMP.shift();
        let options = [
            question.opcion1,
            question.opcion2,
            question.opcion3,
            question.opcion4,
        ];

        question.options = options.sort(() => 0.5 - Math.random());

        setCurrentQuestion(question);
        setQuestions(questionsTMP);
        setMyAnswer(null);

        initTimer()
    }

    const formatResponseTime = () => {
        if (!myAnswer || !myAnswer.diff) return 0;

        let minutes = myAnswer.diff / 60;

        if (minutes > 1) {
            return `${minutes.toFixed(2)}  M.`;
        }

        return `${myAnswer.diff} S.`;
    }

    const saveStats = async () => {
        try {
            const data = {
                estadisticas: stats,
                jugador: session._id,
                totalCorrectas: stats.filter( p => p.esCorrecta ).length,
                totalIncorrectas: stats.filter( p => !p.esCorrecta ).length,
            }

            const response = await IndividualChallengeService.save(state.round.desafio, team.area._id, data);
            
            
            let questions = response.desafio.rondas.map( round => round.jugador1.jugador === session._id ? round.jugador1.estadisticas : round.jugador2.estadisticas );
            questions = [].concat.apply([], questions)

            const infoRound = {
                status: response.estatus,
                nextRound: response.siguienteRonda,
                me: {
                    challengeScore: questions.filter( p => p.esCorrecta).reduce( (a,b) => a+b.puntos, 0),
                    roundScore: stats.filter( p => p.esCorrecta).reduce( (a,b) => a+b.puntos, 0),
                    right: data.totalCorrectas,
                    wrong: data.totalIncorrectas,
                    time: stats.filter( p => p.esCorrecta).reduce( (a,b) => a+b.tiempo, 0),
                    roundsWon: response.desafio.rondas.filter( round => round.ganador === session._id ).length,
                },
                opponent: response.estatus === 0 ? {} : getStatsOpponent(response.desafio.rondas)
            }

            setResponseRound(infoRound);

        } catch (error) {
            console.log(error)
        }
    }

    const getStatsOpponent = (rounds) => {
        const lastRound = rounds[rounds.length-1];
        const statsRound = lastRound.jugador1.jugador !== session._id ? lastRound.jugador1.estadisticas : lastRound.jugador2.estadisticas;

        let questions = rounds.map( round => round.jugador1.jugador !== session._id ? round.jugador1.estadisticas : round.jugador2.estadisticas );
        questions = [].concat.apply([], questions)

        return {
            challengeScore: questions.filter( p => p.esCorrecta).reduce( (a,b) => a+b.puntos, 0),
            roundScore: statsRound.filter( p => p.esCorrecta).reduce( (a,b) => a+b.puntos, 0),
            right: statsRound.filter( p => p.esCorrecta).length,
            wrong: statsRound.filter( p => !p.esCorrecta).length,
            time: statsRound.filter( p => p.esCorrecta).reduce( (a,b) => a+b.tiempo, 0),
            roundsWon: rounds.filter( round => round.ganador !== session._id ).length,
        }
    }

    const initTimer = () => {
        if(!timerBonus.current || !iconBonus.current) return ;

        timerBonus.current.style.animationPlayState = '';
        timerBonus.current.style.animation = '';
        
        iconBonus.current.style.animationPlayState = '';
        iconBonus.current.style.animation = '';

        setTimeout( () => {
            timerBonus.current.style.animation = 'countdown ' + TIME_LIMIT_QUICK_ANSWER + 's linear  forwards';
            iconBonus.current.style.animation = 'hideIconBonus ' + TIME_LIMIT_QUICK_ANSWER + 's linear ';
        })
    }

    return (
        <>
            <div className='round-question'>
                {responseRound && <ModalStatusRound details={responseRound} /> }

                <div className='question'>
                    <div className="container mx-auto px-4 pb-[150px]">
                        <div className='pt-6'>
                            <img src={Logo} alt="" />
                        </div>
                        <div>
                            {preparing()}
                            {!isPreparing && currentQuestion &&
                                <>
                                    <div className='grid gap-x-[16px] grid-cols-12 mt-28'>
                                        <div className='col-span-6 col-start-4'>
                                            <div className='flex'>
                                                <div className='grow'>
                                                    <div className='rounded-[8px] bg-[#ffffff1a] w-fit p-[8px]'>
                                                        <img src={`${SERVER}public/icons-categories/${currentQuestion.categoria.icono}`} alt={currentQuestion.categoria.nombre} className="w-[32px]" />
                                                    </div>
                                                </div>
                                                
                                                <div className='bonus-container'>
                                                    <svg>
                                                        <circle r="21" cx="24" cy="24" ref={timerBonus} ></circle>
                                                    </svg>
                                                    <img src={ICON_BONUS} alt='' ref={iconBonus} />
                                                </div>
                                            </div>
                                            <p className='font-family-montserrat text-[#FF98DF] text-[12px] mt-6 '>{currentQuestion.categoria.nombre}</p>
                                            <p className='text-white text-[20px] mt-3'>{currentQuestion.pregunta}</p>
                                        </div>
                                    </div>

                                    {
                                        currentQuestion.options.map((option, index) => (
                                            <div className='option-container' key={index} onClick={() => handleAnswer(index, option)}>
                                                <div className={'col-span-6 col-start-4 option-answer ' + (myAnswer ? (myAnswer.index === index ? 'selected' : 'disabled') : '')}>
                                                    <div className='option'>{option.respuesta}</div>
                                                </div>
                                                <div className='col-span-3 option-result'>
                                                    <div className='text-white font-bold text-[12px]'>
                                                        <p>{formatResponseTime()}</p>
                                                        <p className='uppercase'>{myAnswer && myAnswer.extraPoints ? TranslateService.get('indivualChall.challenges.round.quickAnswer') + ' 💪' : ''}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </>
                            }


                        </div>
                    </div>

                    {myAnswer &&
                        <div className={'footer-question good ' + (myAnswer.esCorrecta ? 'good' : 'bad')}>
                            <div className='container mx-auto px-4'>
                                <div className='grid gap-x-[16px] grid-cols-12'>
                                    <div className='col-span-6 col-start-4'>

                                        <div className={'points-container ' + (!myAnswer.esCorrecta ? '!hidden' : '')} >
                                            <p className='points'>+{myAnswer.points} PTS</p>

                                            {myAnswer.extraPoints &&
                                                <p className='points'>+{myAnswer.extraPoints} {TranslateService.get('indivualChall.challenges.round.quickAnswerBonus')} 💪</p>
                                            }

                                        </div>

                                        <div className='flex items-center'>
                                            <div className='grow mr-3'>
                                                <p className='heading-h5'>
                                                { myAnswer.esCorrecta?  TranslateService.get('indivualChall.challenges.round.right'): TranslateService.get('indivualChall.challenges.round.wrong')}
                                                </p>
                                                <p>{myAnswer.esCorrecta ? currentQuestion.feedbackCorrecto : currentQuestion.feedbackIncorrecto}</p>
                                            </div>
                                            <Button className={myAnswer.esCorrecta ? 'green' : 'red'} onClick={nextQuestion}>{TranslateService.get('indivualChall.challenges.round.next')}</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    }
                </div>
            </div>

        </>
    )
}